import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function RatingAvisVerifiDemiIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<rect width="24" height="24" fill="#0073FF" />
			<rect x="12" width="12" height="24" fill="#C7DEFF" />
			<g clipPath="url(#clip0_7286_166588)">
				<path
					d="M14.0647 10.3333C13.8005 10.3333 13.5674 10.1605 13.4906 9.90772L12.574 6.89004C12.4016 6.32255 11.5982 6.32255 11.4258 6.89004L10.5092 9.90772C10.4324 10.1605 10.1993 10.3333 9.9351 10.3333H7.20701C6.62317 10.3333 6.38324 11.0826 6.85849 11.4217L9.10041 13.0215C9.31103 13.1718 9.40158 13.4402 9.32505 13.6874L8.44002 16.5459C8.26741 17.1033 8.91165 17.5541 9.37627 17.201L11.6371 15.4824C11.8516 15.3194 12.1484 15.3193 12.3629 15.4822L14.6314 17.2037C15.096 17.5563 15.7398 17.1055 15.5672 16.5483L14.6814 13.6871C14.6049 13.4401 14.6952 13.1718 14.9056 13.0215L17.1442 11.4215C17.619 11.0821 17.3789 10.3333 16.7953 10.3333H14.0647Z"
					fill="white"
				/>
			</g>
			<defs>
				<clipPath id="clip0_7286_166588">
					<rect width="16" height="16" fill="white" transform="translate(4 4)" />
				</clipPath>
			</defs>
		</svg>
	);
}

RatingAvisVerifiDemiIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default RatingAvisVerifiDemiIcon;
